<template>
  <v-app v-if="oidcIsAuthenticated">
    <transition name="fade">
      <waiting v-if="!authorize" />

      <div v-else class="d-flex flex-column flex-root">
        <KTHeaderMobile></KTHeaderMobile>
        <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

        <div class="d-flex flex-row flex-column-fluid page">
          <KTAside v-if="asideEnabled"></KTAside>

          <div
            id="kt_wrapper"
            class="d-flex flex-column flex-row-fluid wrapper"
          >
            <KTHeader></KTHeader>

            <div id="kt_content" class="content d-flex flex-column">
              <div class="d-flex flex-column-fluid">
                <div
                  :class="{
                    'container-fluid': contentFluid,
                    container: !contentFluid,
                  }"
                >
                  <router-view />
                </div>
              </div>
            </div>
            <div>
              <KTFooter></KTFooter>
            </div>
          </div>
        </div>
        <KTScrollTop></KTScrollTop>
      </div>
    </transition>
    <v-snackbar
      :width="announcement && announcement.fullWidth ? '100%' : ''"
      :max-width="announcement && announcement.fullWidth ? '100%' : ''"
      v-if="announcement != ''"
      style="z-index: 999999"
      :timeout="
        announcement && announcement.fadeoutType == 'Unclosable'
          ? -1
          : announcement && announcement.showTimeInSecond
          ? announcement.showTimeInSecond * 1000
          : ''
      "
      :value="announcement != null"
      :color="
        announcement && announcement.alert == 'Alert'
          ? 'orange lighten-1'
          : announcement && announcement.alert == 'Danger'
          ? 'red lighten-1'
          : announcement && announcement.alert == 'Info'
          ? 'blue lighten-1'
          : ''
      "
      absolute
      right
      transition="fab-transition"
      :top="announcement && announcement.location == 'Header'"
      elevation="24"
      :bottom="announcement && announcement.location == 'Footer'"
    >
      <v-row>
        <h2
          class="mt-2"
          v-if="announcement && announcement.title"
          v-html="announcement.title"
        ></h2>
        <v-spacer></v-spacer>
        <v-btn
          v-if="announcement && announcement.fadeoutType != 'Unclosable'"
          icon
          dark
          left
          @click="announcement = ''"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <div
        class="ck-content"
        style="min-height: auto"
        v-if="announcement && announcement.message"
        v-html="announcement.message"
      ></div>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import KTHeader from '@/view/layout/header/Header.vue';
import KTAside from '@/view/layout/aside/Aside.vue';
import KTHeaderMobile from '@/view/layout/header/HeaderMobile.vue';
import KTFooter from '@/view/layout/footer/Footer.vue';
import HtmlClass from '@/core/services/htmlclass.service';
import KTSubheader from '@/view/layout/subheader/Subheader.vue';
import KTStickyToolbar from '@/view/layout/extras/StickyToolbar.vue';
import KTScrollTop from '@/view/layout/extras/ScrollTop';
import Loader from '@/view/content/Loader.vue';
import Waiting from '@/view/layout/extras/Waiting.vue';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const announcementsRepository = () => RepoFactory.get('announcements');
const notificationRepository = () => RepoFactory.get('notification');
import TagsView from './TagsView/index.vue';
import {
  SAVE_WITH_SHORTCUT,
  NEW_WITH_SHORTCUT,
  LIST_WITH_SHORTCUT,
} from '@/core/services/shortCutTypes.js';
export default {
  name: 'LayoutPage',
  data() {
    return {
      announcement: null,
      originalTabTop: 0,
      isHeaderSticky: false,
      activeTab: '',
    };
  },
  components: {
    KTHeader,
    KTAside,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader,
    Waiting,
  },
  beforeMount() {
    HtmlClass.init(this.layoutConfig());
    if (
      localStorage.getItem('sepehr_theme_is_dark') &&
      JSON.parse(localStorage.getItem('sepehr_theme_is_dark'))
    ) {
      this.$vuetify.theme.dark = true;
    }
  },

  mounted() {
    setTimeout(() => {
      this.getAnnouncements();
    }, 400);
    if (!this.oidcIsAuthenticated) {
      this.authenticateOidc();
    }
    this.$nextTick(() => {
      if (
        this.oidcUser &&
        this.oidcUser.role &&
        this.oidcUser.role.includes('supplier') &&
        this.$route.path === '/'
      ) {
        this.$router.replace({ path: '/dashboard' }).catch(() => {});
      }
    });
  },

  watch: {
    oidcIsAuthenticated(after) {
      if (!after) {
        this.authenticateOidc();
      }
    },
    userBusinessInformation(after) {
      if (after) {
        this.getMerchantMessages();
      }
    },
  },
  methods: {
    getAnnouncements() {
      announcementsRepository()
        .getAnnouncements(
          this.baseUrl,
          {},
          {
            moduleType: 'SupplierPanel',
          }
        )
        .then((res) => {
          console.log(res);
          this.announcement = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    ...mapActions('oidc', [
      'oidcSignInCallback',
      'getOidcUser',
      'signOutOidc',
      'authenticateOidc',
    ]),
    getMerchantMessages() {
      notificationRepository()
        .getunseenUserNotification(this.notificationBaseUrl)
        .then((res) => {
          import('@/core/helpers/const').then((res) => {
            const menu = res.merchantMenu.find(
              (menu) => menu.link == '/merchant-messages'
            );
            if (menu) {
              menu.notif = res.data.length;
            }
          });

          this.$store.commit('setMerchantMessages', res.data);
        })
        .catch();
    },
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    ...mapGetters('oidc', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
      'oidcUser',
      'oidcIdToken',
      'oidcIdTokenExp',
      'oidcAccessToken',
    ]),
    ...mapGetters([
      'breadcrumbs',
      'tabs',
      'pageTitle',
      'layoutConfig',
      'shortCuts',
      'authorize',
      'merchantBaseUrl',
      'userBusinessInformation',
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig('content.width') === 'fluid';
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig('aside.self.display');
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig('subheader.display');
    },
  },
};
</script>

<style lang="scss">
/* For Numbers */
* {
  -moz-font-feature-settings: 'ss02';
  -webkit-font-feature-settings: 'ss02';
  font-feature-settings: 'ss02';
}
input[type='number'] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

button,
input,
optgroup,
select,
textarea {
  font-size: 1rem;
}
.card-header {
  background-color: rgba(0, 0, 0, 0.03) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.btn-disable {
  opacity: 0.6;
  pointer-events: none;
}
.v-btn {
  letter-spacing: 0 !important;
}

$nums: 9;
@for $j from 0 through 3 {
  @for $i from 1 through $nums {
    @if $j > 0 {
      .fs-#{$j}-#{$i} {
        font-size: ((($j * 10) + $i) / 10) + rem;
      }
    } @else {
      .fs-#{$j}-#{$i} {
        font-size: ($i / 10) + rem;
      }
    }
  }
}

.gap-0-5 {
  gap: 0.5rem;
}
.gap-0-6 {
  gap: 0.6rem;
}
.gap-0-7 {
  gap: 0.7rem;
}
.gap-0-8 {
  gap: 0.8rem;
}
.gap-0-9 {
  gap: 0.9rem;
}
.gap-1 {
  gap: 1rem;
}

.box-shadow-none {
  box-shadow: none;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.table thead td,
.table thead th {
  font-size: 0.95rem;
  font-weight: 500;
}
.table td,
.table th {
  vertical-align: middle;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  //background: hsl(210deg 50% 95%);
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
}
.position-bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
}

.v-messages__message {
  font-size: 11px;
  font-weight: 400;
}

.online-title {
  position: absolute;
  top: -12px;
  background: #fff;
  padding: 0 1rem;
  color: hsl(240deg 6% 50%);
  right: 10px;
  font-size: 13px;
  font-weight: 500;
  + .v-card__text {
    padding-right: 20px;
  }
}

// OverWrite Vuetify Styles Globally

.theme--light.v-application {
  background: #eef0f8 !important;
}
.v-application {
  .body-1 {
    font-family: Iran Sans, yekan-regular !important;
  }
  .content {
    margin-bottom: auto !important;
  }
  label.v-label.theme--light {
    font-size: 13px;
    text-align: right;
  }

  .v-skeleton-loader.custom-card-skeleton.v-skeleton-loader--is-loading {
    .v-skeleton-loader__chip {
      width: 30%;
      margin: 1rem;
      display: inline-block;
    }
  }

  .theme--light.v-messages {
    color: rgb(0 0 0 / 44%);
  }
}

.v-input {
  font-size: 0.9rem;
}

@media (min-width: 992px) {
  .container,
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    padding: 12px;
  }
}

::-webkit-scrollbar {
  // left: 3px;
  display: block;
  width: 15px !important;
  height: 15px !important;
}

::-webkit-scrollbar-track {
  // direction:rtl;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  right: 100%;
  direction: ltr;
  border-radius: 10px;
  height: 3px !important;
  width: 3px !important;
  margin-top: 0.3rem;
  background: rgba(38, 53, 87, 0.466); /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    rgba(38, 53, 87, 0.466),
    #2c2f5e86
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    rgba(20, 33, 66, 0.384),
    #1a1e4e67
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

::-webkit-scrollbar-track-piece:end {
  // direction:rtl;
  background: transparent;
  margin-bottom: 10px;
}

::-webkit-scrollbar-track-piece:start {
  // direction:rtl;
  background: transparent;
  margin-top: 10px;
}

.v-tooltip__content {
  background: rgb(255, 255, 255);
  font-size: 12px;
  color: #8b8b8b;
  box-shadow: 1px 2px 5px #00000066;
}
.v-treeview-node__root {
  min-height: 35px !important;
}
.v-treeview .v-icon.mdi-checkbox-marked,
.v-treeview .v-icon.mdi-checkbox-blank-outline {
  font-size: 18px !important;
}

.vue-treeselect__menu {
  line-height: 300% !important;
}

.v-application--is-rtl .v-input--selection-controls__input {
  margin-left: 2px !important;
  margin-right: 8px !important;
}
</style>
